import API from 'services/API';
import { map, filter } from 'lodash';
import situationsCodeMap from '../../constants/situationsCodeMapping';

export default function searchSituations(query) {
  return API.request(
    {
      method: 'GET',
      url: `/dicts/find-life-situations`,
      mapper: mapSituations,
      params: { key: query },
    },
    true,
  );
}

//и еще на всякий, если в бд коды ссылок грохнут
function mapSituations(data) {
  return filter(
    map(data, (situation) => {
      return {
        title: situation.name,
        code: situation.linkCode,
        categoryCode: situation.categoryCode,
        themeCode: situation.themeCode,
      };
    }),
    (appeal) => appeal.code && situationsCodeMap[appeal.code],
  );
}
